import { z } from "zod"

import { propertyDataSchema } from "./property-data"
import { tariffRateSchema } from "./tariff-rate"

export const scenarioSchema = z.object({
  /** This is not used for Account Analysis
   * (it’s used for Project Analysis). Will be null.
   * Ignore it. */
  id: z.string().nullable(),
  /** The unique name (key) of this scenario.
   * Solar PV has “before”, “after”, “solar” and “savings”. */
  name: z.string(),
  /** The type of service for this scenario. "ELECTRICITY" or "SOLAR_PV" */
  serviceType: z.string(),
  /** The important inputs that were used in
   * this scenario’s calculation. This defines
   * the usage data profiles, the rate plan and plan
   * arguments and other parameters for the calc.
   * See examples below. */
  inputs: z.array(propertyDataSchema),
  /** Used to pass the site’s specific contracted
   * electricity rates (only needed if they are in a
   * deregulated market), their tax rates (if you want
   * us to calculate post tax numbers), and possibly
   * their solar offers PPA or lease rate. See examples
   * below. */
  rates: z.array(tariffRateSchema).optional(),
})

// Exported type for the Scenario object
export type Scenario = z.infer<typeof scenarioSchema>
